module.exports = __webpack_public_path__ + "assets/img/视频.b9e991eb.svg";